import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28f9bc3c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=28f9bc3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9bc3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28f9bc3c')) {
      api.createRecord('28f9bc3c', component.options)
    } else {
      api.reload('28f9bc3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28f9bc3c&scoped=true&", function () {
      api.rerender('28f9bc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-title/index.vue"
export default component.exports